import React, { useState } from "react";

const RegisterForm = ({
  onSubmit,
  onBackToLogin,
  logoURL,
  clientDescription,
  clientRegistrationInfo,
  message,
  setMessage,
}) => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) return;

    setIsSubmitting(true);
    setMessage("");
    await onSubmit(email);
    setIsSubmitting(false);
  };

  const isSuccess =
    message &&
    (message.toLowerCase().includes("success") ||
      message.toLowerCase().includes("ok"));

  return (
    <div className="inner-form-container">
      <h2>{clientDescription}</h2>
      <img
        src={logoURL ? `${logoURL}` : "https://placehold.co/250x250/png"}
        alt="Brand Logo"
        className="branding-image"
      />
      <h2>Register For Online</h2>
      <div dangerouslySetInnerHTML={{ __html: clientRegistrationInfo }} />

      {message && (
        <div className={isSuccess ? "success-box" : "error-box"}>{message}</div>
      )}

      <form onSubmit={handleFormSubmit} className="form">
        <label className="label">
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
            placeholder="you@example.com"
          />
        </label>
        
        <button type="submit" className="login-button" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Register"}
        </button>
        
        <button
          type="button"
          onClick={onBackToLogin}
          className="register-button"
        >
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default RegisterForm;
